module.exports = __webpack_public_path__ + "static/icon8-dce585cdab54b32d20813cf0bc14483a.svg";